import { getLabel } from "../label/utils";

// The refs.require of a query: the rules and the presets of its clauses, and
// its label. Reads values only.
export function getQueryRefs(values, queryClauses) {
  const items = new Set();
  const presets = new Set();

  queryClauses?.forEach(({ accessor }) => {
    values[accessor] && values[accessor].forEach((k) => items.add(k.id));
    if (values.presets) {
      values.presets[accessor] &&
        values.presets[accessor].forEach((k) => presets.add(k.id));
    }
  });

  const refArray = [
    { type: "rules", items: [...items] },
    { type: "rulesPresets", items: [...presets] }
  ];

  if (values.label) {
    refArray.push({
      type: "labels",
      items: [getLabel(values.label)]
    });
  }

  return refArray;
}
